<nav
    class="flex w-full items-center justify-between border-b border-gray-100 bg-white px-4 py-3 text-gray-700 shadow-sm sm:px-6 dark:border-gray-800 dark:bg-black/40 dark:text-gray-200">
    <div class="flex min-w-0 items-center gap-2">
        <button
            type="button"
            class="hover:bg-primary-soft -ml-1 shrink-0 cursor-pointer rounded-sm p-2 md:hidden"
            aria-label="Toggle navigation menu"
            (click)="sidebarToggle.emit()">
            <i class="pi pi-bars text-xl"></i>
        </button>
        <i
            class="pi pi-shield text-primary hidden shrink-0 text-xl sm:block"></i>
        <span
            class="truncate text-sm font-semibold tracking-wide uppercase sm:text-base">
            Platform Administration
        </span>
    </div>

    <button
        type="button"
        class="hover:bg-primary-soft flex shrink-0 items-center gap-2 rounded-sm px-3 py-2 text-sm font-medium"
        (click)="logout()">
        <i class="pi pi-sign-out"></i>
        <span class="hidden sm:inline">Log Out</span>
    </button>
</nav>
